import React from 'react';
import { Box, VStack, Text, Button, HStack } from '@chakra-ui/react';
import { ScannedQRData } from '@/types/payment';

interface PaymentErrorContentProps {
  qrData: ScannedQRData;
  amount: number;
  errorMessage: string;
  onRetry: () => void;
  onCancel: () => void;
}

export const PaymentErrorContent: React.FC<PaymentErrorContentProps> = ({
  qrData,
  amount,
  errorMessage,
  onRetry,
  onCancel,
}) => {
  return (
    <VStack gap={6} w="full" p={4} userSelect="none">
      {/* エラーアイコン */}
      <Box
        w="80px"
        h="80px"
        borderRadius="full"
        bg="red.500"
        display="flex"
        alignItems="center"
        justifyContent="center"
        animation="shake 0.5s ease-out"
      >
        <Text fontSize="4xl" color="white">
          ✕
        </Text>
      </Box>

      {/* エラーメッセージ */}
      <VStack gap={2}>
        <Text fontSize="2xl" fontWeight="bold" color="gray.800">
          支払いに失敗しました
        </Text>
        <Text fontSize="sm" color="gray.600" textAlign="center">
          もう一度お試しください
        </Text>
      </VStack>

      {/* エラー詳細 */}
      <Box w="full" bg="red.50" borderRadius="lg" p={4} borderWidth="1px" borderColor="red.200">
        <HStack gap={2} mb={2}>
          <Text fontSize="lg">⚠️</Text>
          <Text fontSize="sm" color="red.700" fontWeight="semibold">
            エラー詳細
          </Text>
        </HStack>
        <Text fontSize="sm" color="red.600">
          {errorMessage}
        </Text>
      </Box>

      {/* 支払金額 */}
      <Box w="full" bg="gray.50" borderRadius="lg" p={4}>
        <VStack gap={2}>
          <Text fontSize="xs" color="gray.600">
            支払金額
          </Text>
          <Text fontSize="2xl" fontWeight="bold" color="gray.800">
            ฿{amount.toLocaleString()}
          </Text>
        </VStack>
      </Box>

      {/* 支払先情報 */}
      <Box w="full" bg="gray.50" borderRadius="lg" p={3}>
        <HStack justify="space-between">
          <Text fontSize="sm" color="gray.600">
            支払先
          </Text>
          <Text fontSize="sm" fontWeight="semibold" color="gray.800">
            {qrData.merchantName}
          </Text>
        </HStack>
      </Box>

      {/* アクションボタン */}
      <VStack gap={2} w="full" mt={4}>
        <Button w="full" size="lg" colorPalette="teal" onClick={onRetry}>
          もう一度試す
        </Button>
        <Button w="full" size="lg" variant="ghost" onClick={onCancel}>
          キャンセル
        </Button>
      </VStack>

      {/* ヘルプ情報 */}
      <Box w="full" bg="blue.50" borderRadius="lg" p={3}>
        <HStack gap={2}>
          <Text fontSize="lg">💡</Text>
          <Text fontSize="xs" color="gray.700">
            問題が解決しない場合は、カスタマーサポートにお問い合わせください
          </Text>
        </HStack>
      </Box>
    </VStack>
  );
};
